/**
 * Created by Denis Kuzin on 25 september 2025
 */

const PavilionOrderView = cc.Node.extend({
    ctor: function (maker, orders) {
        this._super();

        this.maker = maker;
        this.orders = orders;

        this.slots = new cleverapps.Spine(bundles.pavilionorderswindow.jsons.order);
        this.slots.setAnimation(0, "animation", false);
        this.addChild(this.slots);

        this.setContentSize2(this.slots.getContentSize());
        this.slots.setAlignment(this.width / 2, this.height / 2);

        this.createAdviceTarget();

        this.createPerson();

        this.updateState(maker);

        this.orders.on("orderStateChanged", this.updateState.bind(this), this);
    },

    createAdviceTarget: function () {
        this.adviceTarget = new cc.Node();
        this.adviceTarget.adviceTarget = Map2d.SPAWN;
        this.adviceTarget.setAlignment(this.width / 2, this.height / 2);
        this.adviceTarget.setVisible(false);
        this.addChild(this.adviceTarget);

        if (cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, unit: this.maker.unit, manualClose: true })) {
            const styles = cleverapps.styles.Map2dAdviceView.straightArrow;
            const arrow = new cc.Sprite(bundles.merge_animations.frames.tutorial_arrow);
            arrow.setPosition(styles.offsetX, styles.offsetY);
            arrow.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.MoveBy(0.5, -styles.deltaX, styles.deltaY).easing(cc.easeInOut(1.7)),
                new cc.MoveBy(0.5, styles.deltaX, -styles.deltaY).easing(cc.easeInOut(1.7))
            )));
            this.adviceTarget.addChild(arrow);
        }
    },

    createPerson: function () {
        const slot = this.slots.getSlot("slot_person");
        const frames = bundles.orders_portraits.frames;

        const person = this.person = new cc.Sprite(frames[this.maker.unit.code] || frames.dwarf);
        cleverapps.UI.fitToBox(person, {
            width: slot.width,
            height: slot.height
        });

        person.setAlignment(slot.width / 2, slot.height / 2);
        slot.addChild(person);
    },

    updateIngredients: function () {
        const state = this.maker.getState();

        if (state === Customer.STATE_COOKING || state === Customer.STATE_READY) {
            if (this.ingredients) {
                this.ingredients.runAction(new cc.Sequence(
                    new cc.FadeOut(0.2),
                    new cc.RemoveSelf()
                ));
                this.ingredients = undefined;
            }
        } else if (state === Customer.STATE_RECIPE) {
            if (!this.ingredients) {
                const styles = cleverapps.styles.PavilionOrderView.ingredients;
                const slot = this.slots.getSlot("slot_ingredients");

                this.ingredientIcons = this.maker.recipe.ingredients.map((ingredient) => new IngredientOrderIcon(ingredient, this.maker, {
                    checkmark: bundles.pavilionorderswindow.frames.order_checkmark,
                    simpleText: true,
                    noGrayEffect: true,
                    iconScale: 1.05,
                    iconPos: styles.iconPos
                }));

                this.ingredients = new cleverapps.Layout(this.ingredientIcons, {
                    direction: cleverapps.UI.HORIZONTAL,
                    margin: styles.margin
                });
                this.ingredients.setAlignment(slot.width / 2, slot.height / 2);
                this.ingredients.setCascadeOpacityEnabledRecursively(true);
                slot.addChild(this.ingredients);
            } else {
                this.ingredientIcons.forEach((icon) => icon.updateAmount({ hideDelta: true }));
            }
        }
    },

    updateRewards: function () {
        const state = this.maker.getState();
        const shouldShowRewards = [Customer.STATE_RECIPE, Customer.STATE_COOKING].includes(state);

        if (state === Customer.STATE_READY || !shouldShowRewards) {
            if (this.rewardsContainer) {
                this.rewardsContainer.runAction(new cc.Sequence(
                    new cc.Spawn(
                        new cc.FadeOut(0.1),
                        new cc.ScaleTo(0.1, 0.2).easing(cc.easeBackIn())
                    ),
                    new cc.RemoveSelf()
                ));
                this.rewardsContainer = undefined;
            }
            return;
        }

        if (this.rewardsContainer) {
            return;
        }

        const styles = cleverapps.styles.PavilionOrderView.rewards;
        const slot = this.slots.getSlot("slot_rewardlist");

        const unitCounts = {};
        this.maker.recipe.order.forEach((item) => {
            const unitKey = Unit.GetKey(item.unit);
            unitCounts[unitKey] = (unitCounts[unitKey] || 0) + item.amount;
        });

        const rewardIcons = [];
        Object.keys(unitCounts).forEach((unitKey) => {
            const unit = Unit.ParseKey(unitKey);
            const count = unitCounts[unitKey];

            rewardIcons.push(UnitView.getUnitImage(unit, { preferStatic: true }));
            rewardIcons.push(cleverapps.UI.generateImageText(`x${count}`, cleverapps.styles.FONTS.PAVILION_ORDER_REWARD_TEXT));
        });

        const provider = this.maker.unit.components.find((component) => component.getOrderRewards);
        if (provider && provider.getOrderRewards()) {
            new RewardsList(provider.getOrderRewards(), { event: cleverapps.EVENTS.EARN.OTHER }).listRewards().forEach((reward) => {
                rewardIcons.push(reward.getIcon());
                rewardIcons.push(cleverapps.UI.generateImageText(`x${reward.getAmount()}`, cleverapps.styles.FONTS.PAVILION_ORDER_REWARD_TEXT));
            });
        }

        const rewardsLayout = new cleverapps.GridLayout(rewardIcons, {
            columns: 2
        });
        rewardsLayout.setAlignment(slot.width / 2, slot.height / 2);
        cleverapps.UI.fitToBox(rewardsLayout, {
            width: slot.width,
            height: slot.height
        });

        const rewardsContainer = this.rewardsContainer = cleverapps.UI.createScale9Sprite(
            bundles.pavilionorderswindow.frames.order_reward_bg,
            cleverapps.UI.Scale9Rect.TwoPixelXY
        );

        const containerWidth = Math.min(rewardsLayout.width * rewardsLayout.scale + styles.padding, slot.width);
        const containerHeight = Math.min(rewardsLayout.height * rewardsLayout.scale + styles.padding, slot.height);

        rewardsContainer.setContentSize(containerWidth, containerHeight);
        rewardsContainer.setAlignment(slot.width / 2, slot.height / 2);
        rewardsContainer.addChild(rewardsLayout);
        rewardsLayout.setAlignment(rewardsContainer.width / 2, rewardsContainer.height / 2);

        slot.addChild(rewardsContainer);
    },

    setupButton: function () {
        if (this.button) {
            this.button.removeFromParent();
            this.button = undefined;
        }

        if (this.maker.getState() === Customer.STATE_READY) {
            return;
        }

        const buttonOptions = {
            onClicked: this.onButtonClick.bind(this)
        };

        let slotName = "slot_button", withAdviceTarget;

        switch (this.maker.getState()) {
            case Customer.STATE_RECIPE:
                if (this.maker.canCook()) {
                    buttonOptions.text = Messages.get("OrdersWindow.button.make");
                    slotName = "slot_submit";
                    withAdviceTarget = true;
                } else if (typeof HungryGamesCustomer !== "undefined" && this.maker.unit.findComponent(HungryGamesCustomer)) {
                    buttonOptions.disabled = true;
                    buttonOptions.text = Messages.get("OrdersWindow.button.make");
                    slotName = "slot_submit";
                } else {
                    buttonOptions.text = this.orders.getBuyIngredientsText(this.maker);
                    buttonOptions.eventName = cleverapps.EVENTS.SPENT.INGREDIENT;
                    buttonOptions.type = cleverapps.styles.UI.Button.Images.button_blue;
                }
                break;

            case Customer.STATE_COOKING:
                buttonOptions.canCoins = true;
                buttonOptions.price = Unit.CalcSpeedUPPrice(this.maker.getCookingTimeLeft());
                buttonOptions.freeIcon = TextWithIcon.ICONS_BY_NAME.speedup;
                buttonOptions.eventName = cleverapps.EVENTS.SPENT.ORDER;
                buttonOptions.speedUp = true;
                buttonOptions.type = cleverapps.styles.UI.Button.Images.button_blue;
                break;

            default:
                buttonOptions.disabled = true;
                buttonOptions.text = Messages.get("OrdersWindow.button.make");
                slotName = "slot_submit";
        }

        const slot = this.slots.getSlot(slotName);
        buttonOptions.width = slot.width;
        buttonOptions.height = slot.height;

        const button = this.button = this.maker.getState() === Customer.STATE_COOKING
            ? new UseGoldButton(buttonOptions)
            : new cleverapps.UI.Button(buttonOptions);

        button.setCascadeOpacityEnabledRecursively(true);
        button.setAlignment(slot.width / 2, slot.height / 2);

        if (withAdviceTarget) {
            this.adviceTarget.replaceParent(slot);
            this.adviceTarget.setPosition(slot.width / 2, slot.height / 2);
            this.adviceTarget.setVisible(true);
        }

        slot.addChild(button);
    },

    createPrize: function () {
        if (this.prize) {
            return;
        }

        const prizeSlot = this.slots.getSlot("slot_prize");
        this.prize = new cleverapps.Spine(bundles.pavilionorderswindow.jsons.prize);
        this.prize.setAnimationAndIdleAfter("open", "idle");
        this.prize.setAlignment(prizeSlot.width / 2, prizeSlot.height / 2);
        prizeSlot.addChild(this.prize);

        const infoButton = new cleverapps.UI.HelpButton({
            callback: () => {}
        });
        infoButton.setAlignment(cleverapps.styles.PavilionOrderView.infoButton);
        prizeSlot.addChild(infoButton);

        const tooltipContent = this.createTooltipContent();
        cleverapps.tooltipManager.create(infoButton, {
            content: tooltipContent,
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            contentSize: tooltipContent.getContentSize()
        });

        this.adviceTarget.replaceParent(prizeSlot);
        this.adviceTarget.setPosition(prizeSlot.width / 2, prizeSlot.height / 2);
        this.adviceTarget.setVisible(true);

        cleverapps.UI.onClick(prizeSlot, this.onButtonClick.bind(this), { hover: true });
    },

    createTooltipContent: function () {
        const styles = cleverapps.styles.PavilionOrderView.tooltip;

        const rewards = {
            unit: this.maker.recipe.order.map(({ amount, unit: { code, stage } }) => ({
                code, stage, amount
            }))
        };

        return new RewardsListComponent(rewards, {
            textDirection: cleverapps.UI.HORIZONTAL,
            font: cleverapps.styles.FONTS.PAVILION_ORDER_TOOLTIP_TEXT,
            iconWrap: styles.iconWrap,
            textMargin: styles.textMargin,
            margin: styles.margin,
            calcColumnsCount: (rewardsCount) => (rewardsCount <= 4 ? rewardsCount : Math.ceil(rewardsCount / 2))
        });
    },

    onButtonClick: function () {
        this.orders.processOrder(this.maker, true);
    },

    updateTimer: function () {
        const styles = cleverapps.styles.PavilionOrderView.timer;
        const slot = this.slots.getSlot("slot_timer");

        if (this.timerContainer) {
            this.timerContainer.stopAllActions();
            this.timerContainer.runAction(new cc.Sequence(
                new cc.FadeOut(0.2),
                new cc.RemoveSelf()
            ));
            this.timerContainer = undefined;
        }

        const hungryGamesCustomer = typeof HungryGamesCustomer !== "undefined" && this.maker.unit.findComponent(HungryGamesCustomer);

        if (this.maker.getState() === Customer.STATE_COOKING) {
            const timerContainer = this.timerContainer = new cc.Sprite(bundles.pavilionorderswindow.frames.timer_bg);
            timerContainer.setPosition(slot.width / 2, slot.height / 2);
            slot.addChild(timerContainer);

            const timer = new cleverapps.CountDownView(new cleverapps.CountDown(this.maker.getCookingTimeLeft()), {
                font: cleverapps.styles.FONTS.PAVILION_ORDER_TIMER_TEXT,
                icon: bundles.pavilionorderswindow.frames.timer_icon
            });

            timer.setAlignment(styles);
            timerContainer.addChild(timer);

            timerContainer.setCascadeOpacityEnabledRecursively(true);
            timerContainer.setOpacity(0);

            timerContainer.runAction(new cc.FadeIn(0.2));
        } else if (hungryGamesCustomer && hungryGamesCustomer.hasLevelTimer() && this.maker.getState() === Customer.STATE_RECIPE) {
            const timerContainer = this.timerContainer = new cleverapps.CountDownView(new cleverapps.CountDown(hungryGamesCustomer.getTimeLeft()), {
                font: cleverapps.styles.FONTS.PAVILION_ORDER_RECIPE_TIMER_TEXT,
                icon: bundles.pavilionorderswindow.frames.timer_icon,
                showHours: false,
                background: {
                    frame: bundles.timer.frames.timer_bg_png,
                    width: styles.recipe.width,
                    height: styles.recipe.height
                }
            });
            timerContainer.setPosition(slot.width / 2 + styles.recipe.dx, slot.height + styles.recipe.dy);
            slot.addChild(timerContainer);

            timerContainer.setCascadeOpacityEnabledRecursively(true);
            timerContainer.setOpacity(0);

            timerContainer.runAction(new cc.FadeIn(0.2));
        }
    },

    updateButton: function () {
        if (this.button) {
            this.button.stopAllActions();
            this.button.disable();
            this.button.runAction(new cc.Sequence(
                new cc.FadeOut(0.2),
                new cc.RemoveSelf()
            ));
            this.button = undefined;
        }

        this.setupButton();

        if (this.button) {
            this.button.setOpacity(0);
            this.button.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.FadeIn(0.2)
            ));
        }
    },

    updatePrize: function () {
        if (this.maker.getState() === Customer.STATE_READY) {
            this.createPrize();
        }
    },

    updateState: function (maker) {
        const canCook = this.maker.canCook();

        if (this.maker !== maker && this.canCook === canCook) {
            return;
        }
        this.canCook = canCook;

        this.updateTimer();
        this.updateButton();
        this.updateRewards();
        this.updatePrize();
        this.updateIngredients();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PAVILION_ORDER_TIMER_TEXT: {
        name: "default",
        size: 44,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    PAVILION_ORDER_REWARD_TEXT: {
        size: 48,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    PAVILION_ORDER_TOOLTIP_TEXT: {
        name: "default",
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    PAVILION_ORDER_RECIPE_TIMER_TEXT: {
        name: "default",
        size: 24,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.styles.PavilionOrderView = {
    rewards: {
        padding: 30
    },

    infoButton: {
        x: { align: "right", dx: 25 },
        y: { align: "top", dy: -30 }
    },

    ingredients: {
        margin: -30,
        iconPos: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 28 }
        }
    },

    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 10 },

        recipe: {
            width: 130,
            height: 42,
            dx: -10,
            dy: 334
        }
    },

    tooltip: {
        iconWrap: {
            width: 60,
            height: 60
        },

        textMargin: -8,

        margin: { x: 30 }
    }
};
